export default __webpack_public_path__ + "static/media/Show-documentation.f81d2d6d.md";